import { isPlatformBrowser } from "@angular/common";
import {
  Component,
  Inject,
  PLATFORM_ID,
  AfterViewInit,
  ChangeDetectorRef,
  DestroyRef,
  inject,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MapService } from "@app/services/map.service";
export interface DialogData<T> {
  poi: T;
  name: string;
  mode?: string;
}

@Component({
  selector: "app-mapcomponent",
  templateUrl: "./mapcomponent.component.html",
  styleUrls: ["./mapcomponent.component.scss"],
  standalone: false,
})
export class MapcomponentComponent implements AfterViewInit {
  title = "";
  // protected Leaflet = null;
  protected map = null;
  protected showMap: boolean = false;

  destroyRef = inject(DestroyRef);
  selected = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) protected data: DialogData<any>,
    @Inject(PLATFORM_ID) protected platformId: Object,
    protected mapService: MapService,
    protected cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<MapcomponentComponent>,
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.mapService.Leaflet$.pipe(
        takeUntilDestroyed(this.destroyRef),
      ).subscribe((Leaflet) => {
        if (Leaflet) {
          this.onMapReady();
        }
      });
    }
  }

  onMapReady() {
    if (isPlatformBrowser(this.platformId)) {
      this.map = this.mapService.Leaflet.map("map").setView(
        [
          Array.isArray(this.data.poi)
            ? this.data?.poi[0]?.location?.latitude
            : this.data?.poi?.location?.latitude,
          Array.isArray(this.data.poi)
            ? this.data?.poi[0]?.location?.longitude
            : this.data?.poi?.location?.longitude,
        ],
        15,
      );
      this.mapService.Leaflet.tileLayer(
        "https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png",
        {
          maxZoom: 19,
          attribution:
            '&copy; <a multilang href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        },
      ).addTo(this.map);
      this.map?.invalidateSize();
      this.initMaps();
    }
  }

  initMaps() {
    if (Array.isArray(this.data.poi)) {
      this.data.poi.forEach((item, index) => {
        const popupDiv = document.createElement("div");
        const customIcon = this.mapService.Leaflet.divIcon({
          className: "custom-price-marker",
          html: `<div 
          class="marker-sel"
          style="background-image: url('../../../../assets/icons/karteitem.svg');
          background-size: cover;
          background-position: center;
          display: flex;
          height: 56px;
          color:#000;
          width: 103px;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 16px;
          border-radius: 0.5rem;
          z-index:100"
          >${item.totalPrice?.value}€ p.P.</div>`,
          iconSize: [103, 56],
          iconAnchor: [51, 103],
        });

        let marker = this.mapService.Leaflet.marker(
          [Number(item?.location?.latitude), Number(item?.location?.longitude)],
          {
            icon: customIcon,
          },
        ).addTo(this.map);

        if (this.data.mode == "small") {
          marker.on("click", () => {
            this.selected = index;
            this.cdr.detectChanges();
            const ref = document.getElementById("details");
            const cls = document.getElementById("map-wrapper");
            if (cls) {
              cls.classList.add("heightMin");
            }
            if (ref) {
              ref.classList.add("show");
              ref.innerHTML = item.popup;
              ref
                .querySelector(".hotel-details-btn")
                ?.addEventListener("click", () => {
                  this.popup(item, index);
                });
            }
          });
          this.map.on("click", (e: any) => {
            if (!e.originalEvent.target.closest(".leaflet-marker-icon")) {
              const ref = document.getElementById("details");
              const cls = document.getElementById("map-wrapper");
              if (cls) {
                cls.classList.remove("heightMin");
              }
              if (ref) {
                ref.classList.remove("show");
              }
            }
          });
        } else {
          marker.on("click", () => {
            this.selected = index;
            this.cdr.detectChanges();
          });
          popupDiv.innerHTML = item.popup;
          popupDiv
            .querySelector(".hotel-details-btn")
            ?.addEventListener("click", () => {
              this.popup(item, index);
            });

          marker.bindPopup(popupDiv).addTo(this.map);
        }

        this.map.on("popupclose", (e) => {
          this.selected = null;
          this.cdr.detectChanges();
        });
      });
    } else {
      this.title = this.data.poi.name;

      this.mapService.Leaflet.marker(
        [
          Number(this.data?.poi?.location?.latitude),
          Number(this.data?.poi?.location?.longitude),
        ],
        {
          icon: this.mapService.Leaflet.icon({
            iconSize: [25, 41],
            iconAnchor: [13, 41],
            iconUrl: "leaflet/marker-icon.png",
            shadowUrl: "leaflet/marker-shadow.png",
          }),
        },
      )
        .bindPopup(this.data.poi.name)
        .addTo(this.map);
    }

    this.map?.invalidateSize();
    this.cdr.detectChanges();
  }

  popup(item, index) {
    this.dialogRef.close({ details: true, item, index });
  }

  angebot() {
    this.dialogRef.close({ angebot: true, index: this.selected });
  }
}
